<template>
  <cTable
    :fields="fields"
    :header="header"
    :methods="methods"
    :modals="modals"
    :config="config"
    ref="table"
  >
    <!-- <template #TEST="{field,row}">
        <Button>{{row[field.key]}}</Button>
      </template> -->
    <template #header>
      <Tabs type="card" v-model="tabName" @on-click="handleTab">
        <TabPane
          v-for="(item, idx) in tabList"
          :key="idx"
          :label="$t(item)"
          :name="item"
        />
      </Tabs>
    </template>
  </cTable>
</template>

<script>
import {
  save,
  uploadFile,
  del,
  getList,
  excel,
  src,
  upload,
  download,
  delFile,
  markResult
} from "@/api/forecastManagement/tagService";
import {getAllClient, getAllCustomerService} from "@/api/user/client";
import { getCountry } from "@/api/system/country";
import { getCity } from "@/api/system/city";
import { getAllService } from "@/api/user/internal";
import { getAgent } from "@/api/tracker/agent";
import { getAddress } from "@/api/double/list";
import { delivery_service } from "@/api/public";
import Sku from "./sku.vue";
import cTable from "@/base/common/index";
import { getWarehouse } from "@/api/storage/warehouse";

export default {
  name: "tagService",

  components: {
    cTable
  },
  methods: {
    handleTab() {
      this.$refs["table"].tabName = this.tabName;
      this.$refs["table"].pageConfig.page = 1;
      this.$refs["table"].pageConfig.size = 15;
      this.$refs["table"].resize();
      this.$refs["table"].getList();
      this.$refs["table"].getTable().recalculate(true);
    }
  },
  data() {
    return {
      tabList: ["FBA", "FBN", "draft", "waitConfirm", "rejected"],
      tabName: "FBA",
      warehouse: [],
      methods: {
        list: p => {
          p.label = this.tabName;
          return getList(p);
        },
        save,
        uploadFile,
        del,
        getCountry,
        getCity,
        delivery_service,
        excel,
        src,
        upload,
        download,
        delFile
      },
      config: {
        height: 630
      },
      modals: {
        excel: {
          type: "add",
          methods: {
            ok({ row, close }) {
              if (!row.src.length)
                return this.$Message["error"]({
                  background: true,
                  content: this.$t("upload")
                });
              this.$page.openLoading();
              this.$page
                .handleRequestMethods(
                  "src",
                  {
                    src: row.src.map(t => t.src),
                    task: row.task
                  },
                  true,
                  true
                )
                .then(res => {
                  this.$Message["success"]({
                    background: true,
                    content: res.msg
                  });
                  this.$page.getList();
                  close();
                })
                .catch(() => {});
            },
            cancel() {
              console.log(this);
              // this.table.header.btns.list.forEach(t=>{
              // 	t.fileName = ''
              // })
            }
          },
          footer: {
            show() {
              return this.type !== "read";
            },
            ok: {
              name: this.$t("Confirm Upload file")
            }
          },
          config: {
            title: this.$t("Excel Import"),
            modalBind: {
              width: 1200,
              transfer: true,
              draggable: true,
              sticky: true,
              "reset-drag-position": true,
              styles: {
                top: "30px"
              }
            }
          },
          grid: [{ src: 24 }],
          fields: [
            {
              name: () => this.$t("Upload File"),
              key: "src",
              component: "Upload",
              bind: {
                isButton: true,
                multiple: true,
                fileName: "src"
              },
              beforeUrl: this.$globalUrl,
              default: [],
              methods: {
                beforeUpload: ({ file }) => {
                  let formData = new FormData();
                  formData.append("file", file);
                  upload(formData).then(res => {
                    let modal = this.$refs["table"].getModal("excel");
                    let data = modal.getFormData();
                    data.src.push({
                      src: res.data.payload,
                      name: file.name
                    });
                    this.$refs["table"].getModal("excel").setFormData({
                      src: data.src
                    });
                  });
                  return false;
                }
              }
            }
          ],
          table: {
            config: {
              height: 600,
              resize: false
            },
            fields: [
              {
                name: () => this.$t("Tracking number"),
                key: "airway_number",
                minWidth: 150
              },
              {
                name: () => this.$t("FBA Number"),
                key: "fba",
                minWidth: 150
              },
              {
                name: "SKU",
                key: "sku",
                minWidth: 150
              }
            ]
          }
        },
        files: {
          config: {
            title: this.$t("labelIsReplacedDoneFile"),
            modalBind: {
              width: 800
            }
          },
          footer: {
            show: () => false
          },
          table: {
            config: {
              height: 600,
              resize: false
            },
            fields: [
              {
                name: () => this.$t("fileName"),
                key: "name",
                minWidth: 150
              },
              {
                width: 100,
                name: () => this.$t("operation"),
                fixed: "right",
                key: "operation",
                type: "btns",
                list: [
                  {
                    name: () => this.$t("show"),
                    type: "src",
                    fnName: "previewFun",
                    disabled: ({ row }) => !row.src,
                    bind: {
                      type: "primary"
                    }
                  }
                  // {
                  // 	name: () => this.$t("delete"),
                  // 	type: "delete",
                  // 	fnName: "deleteFun",
                  // 	bind: {
                  // 		type: "error",
                  // 	},
                  // },
                ],

                methods: {
                  deleteFun({ row }) {
                    this.$Modal.confirm({
                      title: this.$t("delete"),
                      width: 300,
                      content: this.$t("titleModal"),
                      onOk: () => {
                        this.handleRequestMethods(
                          "delFile",
                          row.id,
                          true,
                          true
                        ).then(res => {
                          this.getList();
                        });
                      }
                    });
                  },
                  previewFun({ row, field }) {
                    // 判断是否有前缀
                    if (row.src.indexOf('archive.vnlin.com') !== -1) {
                      window.open(row.src);
                    } else {
                      window.open(this.$globalUrl + row.src);
                    }

                  }
                }
              }
            ]
          }
        },
        add: {
          type: "add",
          methods: {
            ok({ row, close }) {
              console.log("chufa1");
              let data = JSON.parse(JSON.stringify(row));
              if (data.case_src) data.case_src = data.case_src.src;
              if (data.sku_src) data.sku_src = data.sku_src.src;
              data.extend = data.extend1.filter(t => t.case_no);
              if (this.$page.tabName === "draft") {
                if (data.id) data.draft = 2;
                else data.draft = 1;
              }
              this.$page
                .handleRequestMethods("save", data, true, true)
                .then(res => {
                  this.$page.getList();
                  close();
                });
            }
          },
          footer: {
            show() {
              return this.type !== "read";
            },
            ok: {
              name() {
                return this.$page.tabName === "draft" && this.params.id
                  ? this.$t("publish")
                  : this.$t("confirm");
              }
            },
            btns: [
              {
                name: this.$t("draft"),
                type: "draft",
                fnName: "draft",
                bind: {
                  type: "success"
                },
                show() {
                  return !this.params.id && this.$page.tabName !== "draft";
                }
              }
            ],
            methods: {
              async draft() {
                let data = await this.$refs["form"].submit();
                console.log("chufa", data);
                data = JSON.parse(JSON.stringify(data));
                if (data.case_src) data.case_src = data.case_src.src;
                if (data.sku_src) data.sku_src = data.sku_src.src;
                data.extend = data.extend1.filter(t => t.case_no);
                data.draft = 1;
                this.$page
                  .handleRequestMethods("save", data, true, true)
                  .then(res => {
                    this.$page.getList();
                    close();
                  });
              }
            }
          },
          config: {
            title: this.$t("add"),
            modalBind: {
              width: 1200,
              draggable: true
            },
            formBind: {
              labelWidth: 120
            },
            rowBind: {
              gutter: 16,
              style: {
                marginBottom: "20px"
              }
            },
            rules: {
              airway_number: [
                {
                  required: true,
                  trigger: "blur"
                }
              ],
              service_name: [
                {
                  required: true,
                  trigger: "blur"
                }
              ],
              type: [
                {
                  required: true,
                  trigger: "blur",
                  type: "number"
                }
              ],
              warehouse_id: [
                {
                  required: true,
                  trigger: "blur",
                  type: "number"
                }
              ],
              extend: [
                {
                  required: true,
                  trigger: "change",
                  type: "array"
                }
              ]
            }
          },
          grid: [
            {
              airway_number: 24
            },
            {
              type: 24
            },
            {
              service_name: 24
            },
            {
              warehouse_id: 24
            },
            {
              tag_src: 24
            },
            {
              remarks: 24
            },
            {
              extend1: 24
            }
          ],
          fields: [
            {
              name: () => this.$t("orderNum"),
              key: "airway_number",
              component: "Input",
              // bind: {
              //   type: "textarea",
              //   rows: 5
              // },
              placeholder() {
                return this.$t("enter") + this.$t("orderNum");
              }
            },
            {
              name: () => this.$t("company"),
              key: "service_name",
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("company");
              },
              options: [],
              methods: {
                list({ field }) {
                  this.$page
                    .handleRequestMethods("delivery_service")
                    .then(res => {
                      field.options = res.payload;
                    });
                }
              }
            },
            {
              name: () => this.$t("shippingMarkLabelReplacedFile"),
              key: "case_src",
              component: "Upload",
              bind: {
                isButton: true,
                fileName: "changeFile",
                multiple: false
              },
              beforeUrl: this.$globalUrl,
              methods: {
                beforeUpload: ({ file }) => {
                  let formData = new FormData();
                  formData.append("file", file);
                  uploadFile(formData).then(res => {
                    console.log(res);
                    this.$refs["table"].getModal("add").setFormData({
                      case_src: {
                        src: res.data.payload,
                        name: file.name
                      }
                    });
                  });
                  return false;
                }
              }
            },
            {
              name: () => this.$t("SKULabelReplacedFile"),
              key: "tag_src",
              beforeUrl: this.$globalUrl,
              component: "Upload",
              bind: {
                isButton: true,
                fileName: "changeFile",
                multiple: true
              },
              default: [],
              methods: {
                fileClick({ row }) {
                  window.open(row.src);
                },
                beforeUpload: ({ file }) => {
                  let formData = new FormData();
                  formData.append("file", file);
                  uploadFile(formData).then(res => {
                    console.log(res);
                    let modal = this.$refs["table"].getModal("add");
                    let tag_src = modal.getFormData().tag_src;
                    if (!tag_src) tag_src = [];
                    tag_src.push({
                      src: res.data.payload,
                      name: file.name
                    });
                    modal.setFormData({
                      tag_src
                    });
                  });
                  return false;
                }
              }
            },
            {
              name: () => this.$t("SKULabelReplacedInfo"),
              key: "extend1",
              render: (h, p) => {
                if (!p.row.extend1)
                  p.row.extend1 = [
                    {
                      case_no: "",
                      sku_num: ""
                    }
                  ];
                return h(Sku, {
                  attrs: {
                    row: p.row,
                    list: p.row.extend1,
                    read: this.$refs["table"].getModal("add").config.formBind
                      .disabled
                  }
                });
              }
            },
            {
              name: () => this.$t("warehouse"),
              key: "warehouse_id",
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("warehouse");
              },
              options: [],
              optionsFn: "predictionWarehouse"
            },
            {
              name: () => this.$t("type"),
              key: "type",
              component: "Select",
              placeholder() {
                return this.$t("select") + this.$t("type");
              },
              options: []
            },
            {
              name: () => this.$t("Remarks"),
              key: "remarks",
              component: "Input",
              bind: {
                type: "textarea",
                rows: 5
              },
              placeholder() {
                return this.$t("enter") + this.$t("Remarks");
              }
            }
          ]
        }
      },
      header: {
        config: {
          custom: false
        },
        searchs: [
          {
            key: "startTime",
            component: "DatePicker",
            placeholder() {
              return this.$t("start") + this.$t("date") + this.$t("time");
            },
            bind: {
              type: "datetime",
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                }
              },
              style: {
                width: "175px"
              }
            },
            methods: {
              "on-change"({ searchForm }) {
                searchForm.startTime = searchForm.startTime
                  ? this.$page.format.timeFormat(searchForm.startTime)
                  : "";
              }
            }
          },
          {
            key: "endTime",
            component: "DatePicker",
            placeholder() {
              return this.$t("end") + this.$t("date") + this.$t("time");
            },
            bind: {
              type: "datetime",
              options: {
                disabledDate(time) {
                  return time.getTime() > Date.now();
                }
              },
              style: {
                width: "175px"
              }
            },
            methods: {
              "on-change"({ searchForm }) {
                let time = this.$page.format.timeFormat(searchForm.endTime);
                if (time.slice(-8) === "00:00:00") {
                  time = time.split(" ")[0] + " " + "23:59:59";
                  searchForm.endTime = time;
                }
              }
            }
          },
          {
            key: "client_id",
            component: "Select",
            placeholder() {
              return this.$t("clientName");
            },
            clearable: true,
            options: [],
            config: {
              label: "account",
              value: "id"
            }
          },
          {
            key: "customerServiceId",
            component: "Select",
            placeholder() {
              return this.$t("select") + this.$t("serviceAccount");
            },
            clearable: true,
            // 数据量大，关闭 filterable，避免选择/输入时实时过滤导致浏览器卡死
            filterable: true,
            options: [],
            bind: {
              style: "width:150px",
            }
          },
          {
            key: "warehouse_id",
            component: "Select",
            placeholder() {
              return this.$t("warehouse");
            },
            clearable: true,
            options: [],
            optionsFn: "predictionWarehouse"
          },
          {
            key: "status",
            component: "Select",
            placeholder() {
              return this.$t("exlType");
            },
            clearable: true,
            options: [
              { value: 2, label: this.$t("unfinished") },
              { value: 3, label: this.$t("operating") },
              { value: 1, label: this.$t("completed") }
            ]
          },
          {
            key: "type",
            component: "Select",
            placeholder() {
              return this.$t("type");
            },
            clearable: true,
            options: []
          },
          {
            key: "create_type",
            placeholder() {
              return this.$tz("创建人,类型");
            },
            component: "Select",
            options: [
              { value: 1, label: "OMS" },
              { value: 2, label: "Portal" }
            ],
            optionsFn: "",
            optionsKey: ""
          },
          {
            key: "keywords",
            placeholder() {
              return this.$t("keyword");
            },
            component: "Input",

            bind: {
              style: "width:140px",
              type: "textarea",
              rows: 2
            }
          }
        ],
        btns: {
          list: [
            {
              name: () => this.$t("add"),
              type: "add",
              fnName: "add",
              bind: {
                icon: "md-add",
                type: "warning"
              }
            },
            {
              name: () => this.$t("export"),
              type: "export",
              fnName: "export",
              bind: {
                icon: "md-arrow-down",
                type: "primary"
              }
            },
            {
              name: () => this.$t("download_tem"),
              type: "down",
              fnName: "down",
              bind: {
                icon: "md-download",
                type: "warning"
              }
            },
            {
              name: () => this.$t("Batch Upload"),
              type: "ExcelImport",
              fnName: "ExcelImport",
              component: "Upload",
              upBind: {
                accept: ".xlsx,.xls"
              },
              bind: {
                showUploadList: false,
                icon: "ios-cloud-upload",
                type: "warning"
              }
            },
            {
              name: () => this.$t("labelIsReplacedDoneFileBatchDownload"),
              type: "download",
              fnName: "download",
              bind: {
                icon: "md-arrow-down",
                type: "primary"
              }
            }
          ],
          methods: {
            download() {
              this.handleRequestMethods("download", {
                ids: this.selectAll.map(t => t.id)
              }).then(
                res => {
                  console.log(res);
                  window.open(res.payload);
                },
                true,
                true
              );
            },
            down() {
              window.open(this.$globalUrl + "/doc/zh-CN/swap.xls", "_black");
            },
            ExcelImport({ file }) {
              let formData = new FormData();
              formData.append("file", file);
              this.$page
                .handleRequestMethods("excel", formData, true, true)
                .then(res => {
                  res.payload.src = [];
                  this.$page.getModal("excel").open(res.payload, function() {
                    this.list.push(...res.payload.rows);
                  });
                });
              return false;
            },
            export({ searchForm }) {
              this.handleRequestMethods("list", {
                ...searchForm,
                export: 1,
                ids: this.selectAll.map(t => t.id)
              }).then(
                res => {
                  console.log(res);
                  window.open(this.$globalUrl + res.payload.src);
                },
                true,
                true
              );
              // this.exportExc();
            },
            add() {
              this.getModal("add").open({ tag_src: [] }, function() {
                if (this.config.formBind) this.config.formBind.disabled = false;
                this.setTitle(this.$t("add"));
                this.type = "add";
              });
            }
          }
        }
      },
      fields: [
        {
          type: "checkbox",
          align: "center",
          width: 60
        },
        {
          name: () => this.$t("Tracking number"),
          key: "airway_number",
          align: "center",
          minWidth: 110
        },
        {
          name: () => this.$t("clientName"),
          key: "client_name",
          align: "center",
          minWidth: 110
        },
        {
          name: () => this.$tz("客服"),
          key: "cs_name",
          minWidth: 110
        },
        {
          name: () => this.$t("type"),
          key: "type_name",
          align: "center",
          minWidth: 110
        },
        {
          name: () => this.$tz("换标,数量"),
          key: "number",
          minWidth: 110
        },
        {
          name: () => this.$t("warehouseName"),
          key: "warehouse",
          align: "center",
          minWidth: 110
        },
        {
          name: () => this.$t("createUser"),
          key: "create_name",
          align: "center",
          minWidth: 110
        },

        {
          name: () => this.$t("createTime"),
          key: "create_time",
          align: "center",
          minWidth: 110
        },
        {
          name: () => this.$t("tip"),
          key: "status",
          align: "center",
          minWidth: 110
        },
        {
          name: () => this.$tz("操作,时间"),
          key: "operate_time",
          minWidth: 110
        },
        {
          name: () => this.$tz("完成,时间"),
          key: "complete_time",
          minWidth: 110
        },
        {
          name: () => this.$t("Remarks"),
          key: "remarks",
          align: "center",
          minWidth: 110
        },
        {
          width: 150,
          name: () => this.$t("operation"),
          fixed: "right",
          key: "operation",
          type: "btns",
          list: [
            {
              name: () => this.$t("update"),
              type: "update",
              fnName: "update",
              bind: {
                type: "success"
              }
            },
            {
              name: this.$t("showDetail"),
              type: "show",
              fnName: "show",
              bind: {
                type: "info"
              }
            },
            {
              name: () => this.$t("SKULabelReplacedFile"),
              type: "src",
              fnName: "previewFun",
              disabled: ({ row }) => !row.src,
              bind: {
                type: "primary"
              }
            },
            {
              name: this.$t("delete"),
              type: "delete",
              fnName: "delete"
            },
            {
              name: this.$t("labelIsReplacedDoneFile"),
              type: "files",
              fnName: "files",
              bind: {
                type({ row }) {
                  return row.isUpload ? "primary" : "default";
                }
              }
            },
            {
              name: this.$t("审核申请"),
              type: "processRequest",
              fnName: "processRequest",
              show: ({ row }) => row.statusVal === 3,
              bind: {
                type: "primary"
              }
            }
          ],

          methods: {
            processRequest({ row }) {
              // 审核提示：通过 / 拒绝 两个按钮，分别调用 markResult
              // 拒绝时需填写失败原因
              let rejectReason = '';
              this.$Modal.confirm({
                title: '审核确认',
                content: '<p>请确认改换标操作是否合理？合理请选择通过，不合理请选择拒绝然后通知客户重新发起</p>',
                okText: this.$t("通过"),
                cancelText: this.$t("拒绝"),
                render: h => {
                  return h('div', [
                    h('div', { style: 'margin-bottom:10px;color:#606266;' }, '审核失败原因：'),
                    h('Input', {
                      props: {
                        type: 'textarea',
                        rows: 3,
                        placeholder: '请填写拒绝原因，将通过 markResult 提交'
                      },
                      on: {
                        input: val => {
                          rejectReason = val;
                        }
                      }
                    })
                  ]);
                },
                onOk: () => {
                  this.$Spin.show();
                  markResult({ id: row.id, result: 1 }).then(res => {
                    this.$Spin.hide();
                    if (res.data.code === 0) {
                      this.$Message.success({
                        content: res.data.msg || '审核通过成功',
                        duration: 2,
                        onClose: () => {
                          this.getList();
                        }
                      });
                    } else {
                      this.$Message.error({
                        content: res.data.msg || '审核通过失败'
                      });
                    }
                  }).catch(() => {
                    this.$Spin.hide();
                    this.$Message.error({
                      content: '审核通过失败'
                    });
                  });
                },
                onCancel: () => {
                  this.$Spin.show();
                  markResult({ id: row.id, result: 0, reason: rejectReason }).then(res => {
                    this.$Spin.hide();
                    if (res.data.code === 0) {
                      this.$Message.success({
                        content: res.data.msg || '审核拒绝成功',
                        duration: 2,
                        onClose: () => {
                          this.getList();
                        }
                      });
                    } else {
                      this.$Message.error({
                        content: res.data.msg || '审核拒绝失败'
                      });
                    }
                  }).catch(() => {
                    this.$Spin.hide();
                    this.$Message.error({
                      content: '审核拒绝失败'
                    });
                  });
                }
              })
            },
            files({ row }) {
              this.getModal("files").open({}, function() {
                this.list = row.swap_src;
              });
            },
            enclosure({ row }) {
              window.open(row.enclosure);
            },
            previewFun({ row, field }) {
              window.open(row[field.type]);
            },
            show({ row }) {
              let data = JSON.parse(JSON.stringify(row));
              if (data.case_src)
                data.case_src = {
                  src: data.case_src,
                  preview: true,
                  name: this.$t("shippingMarkLabelReplacedFile")
                };
              if (data.sku_src)
                data.sku_src = {
                  src: data.sku_src,
                  preview: true,
                  name: this.$t("SKULabelReplacedFile")
                };
              if (!data.extend.length) {
                data.extend.push({});
              }
              data.extend1 = data.extend;
              this.getModal("add").type = "read";
              this.getModal("add").open(data, function() {
                this.config.formBind.disabled = true;
                this.setTitle(this.$t("showDetail"));
              });
            },
            update({ row }) {
              let data = JSON.parse(JSON.stringify(row));
              if (data.case_src)
                data.case_src = {
                  src: data.case_src,
                  preview: true,
                  name: this.$t("shippingMarkLabelReplacedFile")
                };
              if (data.sku_src)
                data.sku_src = {
                  src: data.sku_src,
                  preview: true,
                  name: this.$t("SKULabelReplacedFile")
                };
              if (!data.extend.length) {
                data.extend.push({});
              }
              data.extend1 = data.extend;
              this.getModal("add").type = "update";
              this.getModal("add").open(data, function() {
                this.config.formBind.disabled = false;
                this.setTitle(this.$t("update"));
              });
            },
            delete({ row }) {
              this.$Modal.confirm({
                title: this.$t("delete"),
                width: 300,
                content: this.$t("titleModal"),
                onOk: () => {
                  this.handleRequestMethods("del", row.id).then(res => {
                    this.$Message["success"]({
                      background: true,
                      content: res.msg
                    });
                    this.getList();
                  });
                }
              });
            }
          }
        }
      ]
    };
  },
  async mounted() {
    let client = (await getAllClient()).data.payload.rows;
    // 客户列表按 id 去重，避免 header Select 的 Option 出现重复 key
    client = Array.from(new Map(client.map(t => [t.id, t])).values());
    // this.warehouse = (await getWarehouse()).data.payload.rows;
    let source = await this.$sel.getData(["CHANGE_TAG_TYPE"]);
    this.header.searchs.forEach(item => {
      if (item.key === "client_id") item.options = client;
      // if (item.key === "warehouse_id") item.options = this.warehouse;
      if (item.key === "type") item.options = source["CHANGE_TAG_TYPE"];
    });
    this.modals.add.fields.forEach(t => {
      // if (t.key === "warehouse_id") {
      //   t.options = this.warehouse;
      // }
      if (t.key === "type") t.options = source["CHANGE_TAG_TYPE"];
    });

    // 加载客服角色
    getAllCustomerService().then(res => {
      // 组合数据
      let buff = []
      res.data.payload.forEach(t => {
        buff.push({
          label: t.account + ' ' + t.realname,
          value: t.id
        })
      })
      this.header.searchs.forEach(item => {

        if (item.key === 'customerServiceId') {
          item.options = buff
        }
      })
    });
  }
};
</script>
